import { Component, computed, inject } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { LayoutService } from '@wayout-admin/shell';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '@wayout-admin/util';
import { MessagePopupService } from '@wayout-fe/util';
import { NgClass } from '@angular/common';
import { AuthHttpService } from '@wayout-admin/data-access';

@Component({
	selector: 'wo-login',
	imports: [
		CheckboxModule,
		InputTextModule,
		ReactiveFormsModule,
		RouterModule,
		IconFieldModule,
		InputIconModule,
		ButtonModule,
		TranslatePipe,
		NgClass,
	],
	templateUrl: './login.component.html',
	styleUrl: './login.component.scss',
})
export class LoginComponent {
	private readonly layoutService = inject(LayoutService);
	private readonly fb = inject(FormBuilder);
	private readonly authService = inject(AuthService);
	private readonly authHttpService = inject(AuthHttpService);
	private readonly messageService = inject(MessagePopupService);
	private readonly router = inject(Router);

	isDarkTheme = computed(() => this.layoutService.isDarkTheme());
	hidePassword = true;
	form = this.fb.group({
		username: ['', Validators.required],
		password: ['', Validators.required],
	});

	login() {
		if (this.form.valid) {
			const { username, password } = this.form.value;
			if (!username || !password) {
				return;
			}

			this.authHttpService.login(username, password).subscribe({
				next: (response) => {
					this.authService.setUser(response);
					this.router.navigate(['/admin']);
				},
				error: (error) => {
					this.messageService.error('login.error.summary', 'login.error.detail');
				},
			});
		}
	}
}
